export { default } from './TrialPaymentPalmistry';
